import * as XLSX from 'xlsx'

export function exportAttendance(records, orgConfig, format = 'xlsx', filename = 'campusflow-attendance') {
  const idLabel = orgConfig?.id_field_label || 'ID'
  const rows = records.map(r => ({
    'Name': r.members?.name || r.member_name || '',
    [idLabel]: r.members?.member_id || r.member_uid || '',
    'Session': r.sessions?.name || r.session_name || '',
    'Group': r.sessions?.group_name || '',
    'Date': new Date(r.marked_at).toLocaleDateString(),
    'Time': new Date(r.marked_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    'Status': r.status,
    'GPS Verified': r.gps_verified ? 'Yes' : 'No',
    'Override Reason': r.override_reason || '',
    'Device Token': r.device_token || '',
  }))
  const ws = XLSX.utils.json_to_sheet(rows)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Attendance')
  const cols = Object.keys(rows[0] || {}).map(k => ({
    wch: Math.max(k.length, ...rows.map(r => String(r[k] || '').length)) + 2,
  }))
  ws['!cols'] = cols
  XLSX.writeFile(wb, filename + (format === 'csv' ? '.csv' : '.xlsx'), { bookType: format === 'csv' ? 'csv' : 'xlsx' })
}

export function exportMembers(members, orgConfig, filename = 'campusflow-members') {
  const idLabel = orgConfig?.id_field_label || 'ID'
  const groupLabel = orgConfig?.group_label || 'Group'
  const rows = members.map(m => ({
    'Name': m.name,
    [idLabel]: m.member_id,
    [groupLabel]: m.group_name || '',
    'Email': m.email || '',
    'Phone': m.phone || '',
    'Added On': new Date(m.created_at).toLocaleDateString(),
  }))
  const ws = XLSX.utils.json_to_sheet(rows)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Members')
  XLSX.writeFile(wb, filename + '.xlsx')
}
